import {Injectable, Injector} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import { AuthService } from '../services/auth.service';
import { factory } from '../shared/app-logging';

const logger = factory.getLogger('RedirectGuard');

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard  {

  constructor(private injector: Injector) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const targetURL = next.data ? next.data['externalUrl'] : null;
    if (!targetURL) {
      return false;
    }
    if (next.data && next.data['logout']) {
      this.injector.get(AuthService).logout();
    }
    logger.info('Redirecting: ' + targetURL);
    window.open(targetURL, '_self');
    return true;
  }
}
